import { Heading, Text, VStack } from '@chakra-ui/react';
import { LucideIcon } from 'lucide-react';
import { FC } from 'react';
import { GradientIcon } from '~/common/components/GradientIcon';

type CardEmptyStateProps = {
  title: string;
  description: React.ReactNode;
  icon: LucideIcon;
};

export const CardEmptyState: FC<CardEmptyStateProps> = (props) => {
  return (
    <VStack alignItems="center" height="100%" justifyContent="center" p={4}>
      <GradientIcon height="44px" icon={props.icon} width="44px" />
      <Heading as="h2" fontSize="20px" size="md" textAlign="center">
        {props.title}
      </Heading>
      <Text color="whiteAlpha.600" textAlign="center">
        {props.description}
      </Text>
    </VStack>
  );
};
